import React, { useState } from 'react';
import {
    Table, Button, Card, Space, Form, Input, Select, Typography, Tag, Segmented,
    Popconfirm, message
} from 'antd';
import { PlusOutlined, SearchOutlined, ReloadOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Title, Text } = Typography;

const ROLE_OPTIONS = [
    { label: '平台视角', value: 'platform' },
    { label: '企业视角', value: 'enterprise' },
];

// mock 当前企业（企业视角）
const CURRENT_ENT = { name: '汇云科技', id: 'ENT-HUIYUN-01' };

// TODO: 联调时替换为接口数据
const PACKAGE_DATA = [
    { id: 1, name: '月享10GB流量包', pkgId: 'PKG_10G_M', pool: '麦联宝', quota: 10, priceCny: 29, priceUsd: 4.99, entId: '0', entName: '鹤梦云平台', apps: ['小鹤看家 · iOS-国内', '云视App · Android-国内'], channels: ['微信支付', '支付宝'], online: true, createTime: '2026-09-08 10:30:00' },
    { id: 2, name: '季度畅享30GB', pkgId: 'PKG_30G_Q', pool: '万物互联电信', quota: 30, priceCny: 79, priceUsd: 12.99, entId: 'ENT-HUIYUN-01', entName: '汇云科技', apps: ['云视App · iOS-国内'], channels: ['Apple Pay', 'Google Pay'], online: true, createTime: '2026-09-09 14:05:21' },
    { id: 3, name: '年度畅享100GB', pkgId: 'PKG_100G_Y', pool: '万物互联电信', quota: 100, priceCny: 199, priceUsd: 29.99, entId: 'ENT-HUIYUN-01', entName: '汇云科技', apps: ['云视App · Android-海外', '慧眼App · iOS-国内'], channels: ['微信支付', 'PayPal'], online: false, createTime: '2026-09-10 09:18:47' },
    { id: 4, name: '体验1GB流量包', pkgId: 'PKG_1G_T', pool: '五兴科技', quota: 1, priceCny: 6, priceUsd: 0.99, entId: 'ENT-XIAOHE-88', entName: '小鹤看家', apps: ['小鹤看家 · Android-国内'], channels: ['微信支付'], online: false, createTime: '2026-09-11 16:42:09' },
];

const PackageList = () => {
    const navigate = useNavigate();
    const [mockRole, setMockRole] = useState('platform');
    const [searchForm] = Form.useForm();
    const [data, setData] = useState(PACKAGE_DATA);

    const isPlatform = mockRole === 'platform';
    const dataSource = isPlatform
        ? data
        : data.filter((d) => d.entId === CURRENT_ENT.id);

    const toggleOnline = (record, checked) => {
        setData((prev) => prev.map((d) => (d.id === record.id ? { ...d, online: checked } : d)));
        message.success(checked ? '已上架' : '已下架');
    };

    const handleDelete = (record) => {
        setData((prev) => prev.filter((d) => d.id !== record.id));
        message.success('已删除');
    };

    const columns = [
        {
            title: '套餐名称', key: 'name', width: 220,
            render: (_, r) => (
                <div>
                    <div style={{ fontWeight: 500 }}>{r.name}</div>
                    <Text type="secondary" style={{ fontSize: 12 }}>ID: {r.pkgId}</Text>
                </div>
            ),
        },
        { title: '所属流量池', dataIndex: 'pool', key: 'pool', width: 150 },
        {
            title: '流量额度', dataIndex: 'quota', key: 'quota', width: 110,
            render: (q) => `${q} GB`,
        },
        { title: '人民币售价', dataIndex: 'priceCny', key: 'priceCny', width: 120, render: (v) => `¥ ${Number(v).toFixed(2)}` },
        { title: '美元售价', dataIndex: 'priceUsd', key: 'priceUsd', width: 120, render: (v) => `$ ${Number(v).toFixed(2)}` },
        ...(isPlatform
            ? [{
                title: '所属企业', key: 'ent', width: 180,
                render: (_, r) => (
                    <div>
                        <div>{r.entId === '0' ? '鹤梦云平台' : r.entName}</div>
                        <Text type="secondary" style={{ fontSize: 12 }}>{r.entId}</Text>
                    </div>
                ),
            }]
            : []),
        {
            title: '投放 App', dataIndex: 'apps', key: 'apps', width: 220,
            render: (apps) => apps.map((a) => <Tag key={a} color="blue">{a}</Tag>),
        },
        {
            title: '支付方式', dataIndex: 'channels', key: 'channels', width: 220,
            render: (channels) => channels.map((c) => <Tag key={c}>{c}</Tag>),
        },
        {
            title: '状态', dataIndex: 'online', key: 'online', width: 100,
            render: (online) => (online ? <Tag color="green">已上架</Tag> : <Tag color="default">已下架</Tag>),
        },
        { title: '创建时间', dataIndex: 'createTime', key: 'createTime', width: 180 },
        {
            title: '操作', key: 'action', fixed: 'right', width: 210,
            render: (_, r) => (
                <Space size={0}>
                    <Button type="link" size="small" onClick={() => navigate(`/traffic/package/edit/${r.id}`)}>编辑</Button>
                    {r.online ? (
                        <Popconfirm title="确认下架该套餐？" onConfirm={() => toggleOnline(r, false)}>
                            <Button type="link" size="small" danger>下架</Button>
                        </Popconfirm>
                    ) : (
                        <>
                            <Button type="link" size="small" onClick={() => toggleOnline(r, true)}>上架</Button>
                            <Popconfirm title="确认删除该套餐？" onConfirm={() => handleDelete(r)}>
                                <Button type="link" size="small" danger>删除</Button>
                            </Popconfirm>
                        </>
                    )}
                </Space>
            ),
        },
    ];

    return (
        <div style={{ padding: 24 }}>
            <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Title level={4} style={{ margin: 0 }}>流量套餐</Title>
                <Space size={8}>
                    <Text type="secondary" style={{ fontSize: 12 }}>mock 角色视角切换</Text>
                    <Segmented value={mockRole} onChange={setMockRole} options={ROLE_OPTIONS} />
                </Space>
            </div>

            <Card bordered={false} style={{ marginBottom: 16, borderRadius: 8 }}>
                <Form layout="inline" form={searchForm}>
                    <Form.Item name="name" style={{ marginBottom: 0 }}>
                        <Input placeholder="套餐名称" allowClear style={{ width: 200 }} />
                    </Form.Item>
                    <Form.Item name="pool" style={{ marginBottom: 0 }}>
                        <Select
                            placeholder="所属流量池" allowClear showSearch optionFilterProp="label"
                            style={{ width: 180 }}
                            options={[
                                { label: '麦联宝', value: '麦联宝' },
                                { label: '万物互联电信', value: '万物互联电信' },
                                { label: '桔子智联', value: '桔子智联' },
                                { label: '五兴科技', value: '五兴科技' },
                                { label: '天贝云客猫', value: '天贝云客猫' },
                            ]}
                        />
                    </Form.Item>
                    <Form.Item name="status" style={{ marginBottom: 0 }}>
                        <Select
                            placeholder="状态" allowClear style={{ width: 140 }}
                            options={[{ label: '已上架', value: 'online' }, { label: '已下架', value: 'offline' }]}
                        />
                    </Form.Item>
                    <Form.Item style={{ marginBottom: 0 }}>
                        <Space>
                            <Button type="primary" icon={<SearchOutlined />} onClick={() => message.info('查询')}>查询</Button>
                            <Button icon={<ReloadOutlined />} onClick={() => searchForm.resetFields()}>重置</Button>
                        </Space>
                    </Form.Item>
                </Form>
            </Card>

            <Card bordered={false} style={{ borderRadius: 8 }}>
                <div style={{ marginBottom: 16 }}>
                    <Button type="primary" icon={<PlusOutlined />} onClick={() => navigate('/traffic/package/create')}>创建套餐</Button>
                </div>
                <Table
                    rowKey="id"
                    columns={columns}
                    dataSource={dataSource}
                    scroll={{ x: 1400 }}
                    pagination={{ showSizeChanger: true, showTotal: (t) => `共 ${t} 条记录` }}
                />
            </Card>
        </div>
    );
};

export default PackageList;
